import {
  parseStoredValue,
  type ParametroComDescItem,
} from '@/shared/api/controllers/parametrosComDesc';

// The discount-bracket engine lives in `discountsLogic` (dependency-free,
// unit-testable). Re-export it so existing import sites (`from './discounts'`)
// keep working unchanged.
export * from './discountsLogic';

/**
 * Monthly gift ("Regalo") allowance parameter, stored in
 * `99.ABM_ParametrosComDesc` like the discount allowances. The cap lives
 * in `ValorPorcentaje_PCD` (TipoValorAplicado = 'Cantidad'). `<= 0` means
 * no limit — same convention as the discount brackets. Kept here (not in
 * `discountsLogic`) because it needs a value import from a controller.
 */
export const REGALO_MENSUAL_PARAM = 'Regalos de Vendedores';

/** Read the monthly gift cap from the ParametrosComDesc list (0 = sin límite). */
export function readRegaloMensualLimit(params: ParametroComDescItem[]): number {
  const row = params.find((p) => p.fields.Parametro_PCD === REGALO_MENSUAL_PARAM);
  return parseStoredValue(row?.fields.ValorPorcentaje_PCD);
}
